import React from 'react';
import { useTranslation } from '../../i18n';
import { AppIcon } from '../shared';

interface LobbyReadyFooterProps {
  playerCount: number;
  disabled: boolean;
  isPremium: boolean;
  onPremiumClick: () => void;
  onStart: () => void;
}

export const LobbyReadyFooter: React.FC<LobbyReadyFooterProps> = ({
  playerCount,
  disabled,
  isPremium,
  onPremiumClick,
  onStart,
}) => {
  const { t } = useTranslation();

  return (
    <footer className="lobby-footer">
      <div className="lobby-footer__inner">
        <div className="lobby-footer__info">
          <span className="lobby-footer__mascot" aria-hidden>
            <AppIcon name="wavingHand" />
          </span>
          <div className="lobby-footer__copy">
            <strong className="lobby-footer__title">
              {t('lobby.gameSelection.readyTitle')}
            </strong>
            <p className="lobby-footer__hint">{t('lobby.gameSelection.readyHint')}</p>
          </div>
        </div>
        {!isPremium && (
          <button
            type="button"
            className="lobby-footer__premium"
            onClick={onPremiumClick}
          >
            <AppIcon name="premium" fontSize="small" />
            {t('lobby.gameSelection.getPremium')}
          </button>
        )}
        <button
          type="button"
          className="lobby-footer__start"
          onClick={onStart}
          disabled={disabled}
        >
          {t('lobby.gameSelection.startGame', {
            count: playerCount,
            playerLabel: t('common.player', { count: playerCount }),
          })}
        </button>
      </div>
    </footer>
  );
};
